import { atom, computed } from 'nanostores'
import type { ServiceLevelStatus } from '@forest/paywall-core'

export const $serviceLevelStatus = atom<ServiceLevelStatus | null>(null)

// Flips true once the initial entitlement fetch resolves (success or failure),
// so subscription-gated UI can render skeletons instead of a flash-of-non-sub
// while the request is in flight.
export const $serviceLevelReady = atom(false)

export const $isInSubscription = computed(
  $serviceLevelStatus,
  (status) => !!status && status.service_level === 'subscription',
)

export const $isInTrial = computed(
  $serviceLevelStatus,
  (status) =>
    !!status &&
    status.service_level === 'subscription' &&
    status.subscription.is_in_trial,
)
